(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/views/xperten.js') >= 0) return;  svs.modules.push('/modules/matchen/views/xperten.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.matchen=_svs.matchen||{};
_svs.matchen.templates=_svs.matchen.templates||{};
svs.matchen.templates.xperten = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"grid-row\">\n\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":12},"end":{"line":17,"column":21}}})) != null ? stack1 : "")
    + "\n        </div>\n";
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"col-xs-4\">\n                <label class=\"btn-label\">\n                    <input type=\"radio\" name=\"radio-btn-group[]\" value=\""
    + alias2(alias1(depth0, depth0))
    + "\" class=\"xperten-"
    + alias2(alias1(depth0, depth0))
    + " js-xperten\"\n                        "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,"==",(depths[2] != null ? lookupProperty(depths[2],"systemSize") : depths[2]),{"name":"compare","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":24},"end":{"line":13,"column":93}}})) != null ? stack1 : "")
    + ">\n                    <span class=\"btn-toggle btn-toggle-300 btn-toggle-matchen\">"
    + alias2(alias1(depth0, depth0))
    + "</span>\n                </label>\n            </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    return "checked=\"checked\" ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"margin-xs-bottom-1 f-500 f-bold align-left\">Välj antalet rader så fyller PIX! i kupongen åt dig.</div>\n<div class=\"panel panel-default align-center\">\n    <div class=\"panel-body panel-body-button-container\">\n        <p>Välj antalet rader</p>\n\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"systemSizes") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":20,"column":17}}})) != null ? stack1 : "")
    + "\n    </div>\n</div>";
},"useData":true,"useDepths":true});
Handlebars.partials['svs-matchen-xperten'] = svs.matchen.templates.xperten;
})(svs, Handlebars);


 })(window);